import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useRouter} from 'next/router';
import Link from 'next/link';
import {useTranslation} from 'react-i18next';
import {UserOverview} from 'components/common/UserOverview';

import {handleChangeDrawerState} from 'redux/actions/ThemeActions';
import ImgTheme from '../common/ImgTheme';

import UserProfileStyles from './styles/mobile-user-profile.module.scss'
import Api from 'constants/Api';

const ProfileDrawerLinks = () => {
    const {t} = useTranslation()
    const dispatch = useDispatch()
    const ThemeState = useSelector(state => state.Theme)

    const handleShowSupport = (data) => {
        dispatch(handleChangeDrawerState({
            showDrawer: false,
            showSupportDrawer: false,
            showNotificationDrawer: false,
            ...data
        }))
    }

    const LinkIcon = ({iconUrl, text, link, as = undefined, ...props}) => (
        link ?
            <Link href={link} as={as}>
                <a>
                    <div {...props}>
                        <ImgTheme alt={text} src={iconUrl}/>
                        <span className={'text-xs'}>{text}</span>
                    </div>
                </a>
            </Link>
            :
            <div {...props}>
                <ImgTheme alt={text} src={iconUrl}/>
                <span className={'text-xs'}>{text}</span>
            </div>
    )

    return <div className={UserProfileStyles.user_profile__links}>
        <div className={UserProfileStyles.user_profile__links__section}>
            <LinkIcon link={'/plan'} as={'/plan'}
                      iconUrl={'/images/icons/profile-authentication.svg'} text={t('authentication')}/>
            <LinkIcon link={'/profile/info'} as={'/profile/info'}
                      iconUrl={'/images/icons/profile-user-info.svg'} text={t('user_info')}/>
            <LinkIcon link={'/security'} as={'/security'}
                      iconUrl={'/images/icons/profile-security.svg'} text={t('security')}/>
        </div>

        <div className={UserProfileStyles.user_profile__links__section}>
            <LinkIcon link={'/fee'} as={'/fee'}
                      iconUrl={'/images/icons/profile-trading-fee.svg'} text={t('trading_fee')}/>
            <LinkIcon link={'/plan/list'} as={'/plan/list'}
                      iconUrl={'/images/icons/profile-plan.svg'} text={t('user_plans')}/>
            <LinkIcon link={'/invite'} as={'/invite'}
                      iconUrl={'/images/icons/profile-invite.svg'} text={t('user_invite')}/>
        </div>

        <div className={UserProfileStyles.user_profile__links__section}>
            <LinkIcon link={null}
                      iconUrl={'/images/icons/profile-support.svg'}
                      text={t('quick_access_support')}
                      onClick={() => handleShowSupport({
                          showSupportDrawer: !ThemeState.showSupportDrawer
                      })}/>
            <LinkIcon link="https://pingi.co" as="https://pingi.co"
                      iconUrl={'/images/icons/profile-website.svg'} text={t('website')}/>
            <LinkIcon link={'/logout'} as={'/logout'}
                      iconUrl={'/images/icons/profile-logout.svg'} text={t('logout')}/>
        </div>
    </div>
}

const ProfileDrawerInviteBox = () => {
    const {t} = useTranslation()

    return <Link href={'/invite'} as={'/invite'} className={'cursor-pointer'}>
        <div className={UserProfileStyles.user_profile__invite_box}>
            <div>
                <h4 className={'font-bold text-xs'}>{t('profile_drawer_invite_title')}</h4>
                <p className={'mb-0 text-2xs'}>{t('profile_drawer_invite_desc')}</p>
            </div>
            <div>
                <img src={'/images/icons/dashboard-invite-fun.svg'} alt={t('invite_title')}/>
            </div>
        </div>
    </Link>
}

const MobileUserProfile = ({hideDrawer = null}) => {
    const firstInit = useRef(true);
    const router = useRouter()
    const {t} = useTranslation()

    useEffect(() => {
        if (hideDrawer) {
            if (!firstInit.current) {
                hideDrawer('type')
            } else {
                firstInit.current = false
            }

            return () => {
                hideDrawer('type')
            }
        }
    }, [router])

    return <div className={UserProfileStyles.user_profile__content}>
        <UserOverview showActionButton={!!hideDrawer}/>

        <ProfileDrawerInviteBox/>

        <ProfileDrawerLinks/>

    </div>
}

export default MobileUserProfile
